import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { FormFieldWrapper } from './FormFieldWrapper';

export const FormField = ({
  label = '',
  type = 'text',
  name,
  disabled,
  required = false,
  style = {},
  ...props
}) => (
  <FormFieldWrapper
    type={type}
    label={label}
    name={name}
    required={required}
    style={style}
  >
    <Field
      className="swformfield__control"
      type={type}
      name={name}
      disabled={disabled}
      {...props}
    />
  </FormFieldWrapper>
);

FormField.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  style: PropTypes.object
};
